import React, { Component } from 'react';
import { Text, Row, Column } from '../common';
import { string, oneOfType, number } from 'prop-types';

export default class DataField extends Component {
    static propTypes = {
        label: string,
        value: oneOfType([string, number])
    }

    render () {
        const { label, value } = this.props;
        return (
            <Row>
                <Column flex={2} mR={10}>
                    <Text size={11} noWrap text={label} semibold lineHeight='1.6' />
                </Column>
                <Column flex={3}>
                    <Text size={11} text={value} lineHeight='1.6' />
                </Column>
            </Row>
        );
    }
}
